import { Navigate, Route, Routes } from "react-router";
import {
  EditorPage,
  MediaPage,
  NotFoundPage,
  PreviewPage,
  SettingsPage,
  SiteDetailPage,
  SitesPage,
  HomePage,
} from "./routes/pages";
import { TemplatesPage } from "./routes/templates/TemplatesPage";
import { TemplatePreviewPage } from "./routes/templates/TemplatePreviewPage";
import { OnboardingPage } from "./routes/onboarding/OnboardingPage";
import { StorePage } from "./routes/store/StorePage";
import { DashboardPage } from "./routes/dashboard/DashboardPage";
import { ProtectedRoute, SessionRoute } from "./routes/ProtectedRoute";
import { LoginPage } from "./routes/auth/LoginPage";
import { SignupPage } from "./routes/auth/SignupPage";
import { ForgotPasswordPage } from "./routes/auth/ForgotPasswordPage";
import { ResetPasswordPage } from "./routes/auth/ResetPasswordPage";
import { PublicSitePage } from "./routes/public/PublicSitePage";

/**
 * Route table for the Zirro app. Anyone can browse templates and walk
 * through creating a site; creating it, and everything after (dashboard,
 * editor, store), needs an account.
 */
export function AppRoutes() {
  return (
    <Routes>
      {/* Open to everyone, with the session loaded when there is one. */}
      <Route element={<SessionRoute />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/templates" element={<TemplatesPage />} />
        <Route path="/templates/:templateId" element={<TemplatePreviewPage />} />
        <Route path="/app/templates" element={<TemplatesPage />} />
        <Route path="/app/templates/:templateId" element={<TemplatePreviewPage />} />
        <Route path="/app/onboarding" element={<OnboardingPage />} />
      </Route>

      {/* Published public website routes (accessible without sign-in) */}
      <Route path="/s/:slug" element={<PublicSitePage />} />
      <Route path="/s/:slug/*" element={<PublicSitePage />} />
      <Route path="/site/:slug" element={<PublicSitePage />} />
      <Route path="/site/:slug/*" element={<PublicSitePage />} />

      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      {/* Signup has no email verification; old verification links land on the dashboard. */}
      <Route path="/verify-email" element={<Navigate to="/app/dashboard" replace />} />

      <Route element={<ProtectedRoute />}>
        <Route path="/app/dashboard" element={<DashboardPage />} />
        <Route path="/app/sites" element={<SitesPage />} />
        <Route path="/app/sites/:siteId" element={<SiteDetailPage />} />
        <Route path="/app/sites/:siteId/editor" element={<EditorPage />} />
        <Route path="/app/sites/:siteId/preview" element={<PreviewPage />} />
        <Route path="/app/sites/:siteId/store" element={<StorePage />} />
        <Route path="/app/media" element={<MediaPage />} />
        <Route path="/app/settings" element={<SettingsPage />} />
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
